module.exports = __webpack_public_path__ + "static/media/07.e6299b29.jpg";